// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/*\r\n * @Descripttion: 基本样式变量配置\r\n * @Date: 2022-03-30 10:55:04\r\n * @LastEditTime: 2022-04-07 14:08:09\r\n */\n.business-footer[data-v-4b295eeb] {\n  height: 80px;\n  background: #fff;\n}\n.business-footer-content[data-v-4b295eeb] {\n    font-size: 12px;\n    color: #151515;\n    text-align: center;\n    line-height: 80px;\n}\n.business-footer-content-a[data-v-4b295eeb]:hover {\n      color: #409eff;\n}\n", ""]);
// Exports
module.exports = exports;
